import React from 'react';

const SuccessImage = () => {
  return (
    <svg width='121' height='120' viewBox='0 0 121 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M18.5 99V23a8 8 0 0 1 8-8h52a8 8 0 0 1 8 8v76a8 8 0 0 1-8 8h-52a8 8 0 0 1-8-8z' fill='var(--theme-light,#e2cff7)' />
      <path
        d='M30.5 37h44m-44 16H63M30.5 69h29m-29 16h39m-51 14V23a8 8 0 0 1 8-8h52a8 8 0 0 1 8 8v76a8 8 0 0 1-8 8h-52a8 8 0 0 1-8-8z'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='4.4'
        strokeLinecap='round'
      />
      <circle cx='80.5' cy='69' r='23.8' fill='var(--theme-light,#e2cff7)' stroke='var(--theme-primary, #810ea9)' strokeWidth='4.4' />
      <path d='M91.5 62 76.167 76 68.5 69' stroke='var(--theme-primary, #810ea9)' strokeWidth='5.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SuccessImage;
